// The WhatsApp service window only reopens when the client writes to us: replies from the AI, agents
// or follow-ups do not extend it. It expires 24h after `Client.clientLastMessageDate`, which is null
// for clients who never wrote — no window ever opened for them.
const WINDOW_MS = 24 * 60 * 60 * 1000;

export const getWhatsAppWindowExpiry = (clientLastMessageDate: Date | string | null | undefined): Date | null =>
  clientLastMessageDate ? new Date(new Date(clientLastMessageDate).getTime() + WINDOW_MS) : null;

export const isWhatsAppWindowOpen = (clientLastMessageDate: Date | string | null | undefined): boolean => {
  const expiresAt = getWhatsAppWindowExpiry(clientLastMessageDate);
  return expiresAt !== null && expiresAt.getTime() > Date.now();
};
